<template>
    <v-dialog v-model="dialog" persistent>
        <v-card class="client-dialog">
            <v-card-title class="grey lighten-3">
                <v-spacer></v-spacer>
                <v-icon v-if="isCorrect" class="success--text">thumb_up</v-icon>
                <v-icon v-else class="error--text">pan_tool</v-icon>
                <v-spacer></v-spacer>
            </v-card-title>
            <v-card-text class="text-xs-center" v-html="message"></v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn round outline color="primary" @click="dismiss()">{{ buttonText }}</v-btn>
                <v-spacer></v-spacer>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    data() {
        return {
            dialog: false,
            isCorrect: null,
            message: null,
            dismissFn: null
        };
    },
    props: {
        buttonText: {
            type: String,
            default: 'Ok'
        }
    },
    methods: {
        show(isCorrect, message, dismissFn) {
            this.dialog = true;
            this.isCorrect = isCorrect;
            this.message = message;
            this.dismissFn = dismissFn;
        },
        dismiss() {
            this.dialog = false;
            this.isCorrect = null;
            this.message = null;
            if (this.dismissFn) {
                this.dismissFn();
            }
            this.dismissFn = null;
        }
    }
};
</script>
